// extracted by mini-css-extract-plugin
module.exports = {"videoMetricsWrapper":"VideoMetrics__videoMetricsWrapper__PebHD","videoBroadcasterMetricsWrapper":"VideoMetrics__videoBroadcasterMetricsWrapper__Dept4"};